import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import heTranslations from './locales/he.json';
import { L10n } from '@syncfusion/ej2-base';

// Syncfusion EJ2 localization (used by Grid Excel filter, etc.)
// Must be loaded early (before components mount) to reliably affect built-in UI text.
L10n.load({
  he: {
    grid: {
      SelectAll: heTranslations?.offices?.['Select All'] || 'בחר הכול',
    },
  },
});

i18n
  // Detect language from browser settings
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      he: {
        translation: heTranslations,
      },
    },
    lng: 'he', // Default language is Hebrew
    fallbackLng: 'he', // Fallback to Hebrew if translation is missing
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },
    
    detection: {
      // Language detection options
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Set document direction and language attributes
const setDocumentDirection = (lang) => {
  if (lang === 'he') {
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.setAttribute('lang', 'he');
  } else {
    document.documentElement.setAttribute('dir', 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }
};

// Set initial direction
setDocumentDirection('he');

// Update direction when language changes
i18n.on('languageChanged', (lng) => {
  setDocumentDirection(lng);
});

export default i18n;
